module.exports = __webpack_public_path__ + "img/paper-dashed.74f87eff.svg";